export const ANALYSIS_STATUS = {
    PENDING: "PENDING",
    PAID: "PAID",
    QUEUED: "QUEUED",
    READY: "READY",
    FAILED: "FAILED",
    ERROR: "ERROR"
}
